<template>
  <svg
    width="49"
    height="56"
    viewBox="0 0 49 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.3908 0C31.5117 0 31.6302 0.010179 31.7455 0.0297261L32.1308 0.0320896C32.705 0.0320896 33.2539 0.265724 33.6536 0.679512L47.911 15.5336C48.2882 15.9249 48.4997 16.4513 48.4997 16.9945V42.7957C48.55 49.8583 43.0497 55.6288 35.9759 55.9159L13.4034 55.9187H13.0966C6.20029 55.7628 0.66935 50.1854 0.50085 43.3564L0.5 12.6399C0.663263 5.65622 6.43095 0.0320896 13.364 0.0320896L31.036 0.0297261C31.1513 0.010179 31.2699 0 31.3908 0ZM29.2793 4.25328L13.3696 4.25441C8.70537 4.25441 4.8321 8.03197 4.72232 12.6906V42.7957C4.61817 47.6176 8.41825 51.5894 13.1923 51.6964H35.8915C40.5895 51.5021 44.3108 47.5979 44.2772 42.8126L44.277 19.6563L38.6194 19.6591C33.4681 19.645 29.2796 15.4452 29.2796 10.2996L29.2793 4.25328ZM30.8649 35.4903C32.0303 35.4903 32.9761 36.4361 32.9761 37.6014C32.9761 38.7668 32.0303 39.7126 30.8649 39.7126H15.6646C14.4992 39.7126 13.5534 38.7668 13.5534 37.6014C13.5534 36.4361 14.4992 35.4903 15.6646 35.4903H30.8649ZM25.1088 24.9288C26.2742 24.9288 27.22 25.8746 27.22 27.04C27.22 28.2054 26.2742 29.1512 25.1088 29.1512H15.6621C14.4967 29.1512 13.5509 28.2054 13.5509 27.04C13.5509 25.8746 14.4967 24.9288 15.6621 24.9288H25.1088ZM33.5016 6.62059L33.5019 10.2996C33.5019 13.1258 35.8017 15.4283 38.625 15.4368L41.9632 15.434L33.5016 6.62059Z"
      :fill="clr ? clr : '#56606B'"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
